/**
 * Member API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'
const memberApi = {
    // 패스워드 변경(Change Password)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-change-password
    changePassword(params) {
        return httpService.put('/membership/member/password', params)
    },

    // 패스워드 다음에 변경(set change after password)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-change-password-next
    changePasswordNext(params) {
        return httpService.put('/membership/member/password/next', params)
    },

    // 프로필 변경(Change Profile)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-change-profile
    uploadProileImage(params) {
        return httpService.put('/membership/member/profile', params)
    },

    // 프로필 조회(get member profile)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-fetch-profile
    getProileImage(params) {
        return httpService.get('/membership/member/profile', params)
    },

    // 리워드 정보 조회
    getMemberReward(params) {
        return httpService.get('/membership/member/reward', params);
    },

    // 소셜 회원 조회
    getMemberSocial(params) {
        return httpService.get('/membership/member/social', params);
    },

    // 비밀번호 체크 {password: password}
    checkPassword(params) {
        return httpService.put('/membership/member/checkPassword', params);
    },

    // 탈퇴요청 params: {reason: Object, comment: String}
    putWithdraw(params) {
        return httpService.put('/membership/member/withdrawal/request', params);
    },

    // 탈퇴사유
    getWithdrawList() {
        return httpService.get('/codes/code/WITHDRAWAL_REASON');
    },

    // 사용자 상세 정보 조회(get member information)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-fetch-info
    getMemberInfo(params) {
        return httpService.get('/membership/member', params)
    },

    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-fetch-info
    emailVarification(params) {
        return httpService.post('/member/membership/auth/email/request', params)
    },

    emailCodeVerfy(params) {
        return httpService.post('/member/membership/auth/email', params)
    },

    //User sign-in authentication request by responsibility
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-responsibility-auth
    authResponsibility(params) {
        return httpService.post('/member/membership/auth/responsibility', params)
    },

    termsAgree(params) {
        return httpService.put('/membership/member/termsAgree', params)
    },
    
    leaderBoard(params) {
        if(params.status=='RANKING'){
            return httpService.get('/membership/point/ranking')
        } else {
            return httpService.get('/membership/point/ranking/store')
        }
        
    },

    addPhoneNo(params){
        return httpService.put('/membership/member', params)
    },

    addDateOfBirth(params){
        return httpService.put('/membership/member', params)
    },
    
    // https://clpapi.tinkeredu.co.kr/static/docs/point.html#resources-level-detail_http_request
    memberPoint(){
        return httpService.get('/membership/member/point')
    },

    languageChangePushNotification(params) {
        return httpService.put('/membership/member/options', params)
    },

    // 즉시 탈퇴 https://dev.clp.kr/api/static/docs/account.html#resources-account-withdrawal
    withdrawAccountDirect(id, params) {
        return httpService.put(`/membership/member/${id}/withdrawal`, params);
    },

    // 탈퇴 요청 https://dev.clp.kr/api/static/docs/account.html#resources-account-withdrawal-request
    withdrawAccountRequest(params) {
        return httpService.put(`/membership/member/withdrawal/request`, params);
    },

    /**
     * 소셜 계정으로 통합(Integrate into social accounts)
     * https://dev.clp.kr/api/static/docs/account.html#resources-account-intergration-social-request
     *
     * @param {object} params
     * @returns {Promise<AxiosResponse<any>>}
     */
    integrateSocialAccount(params) {
        return httpService.post('/social/integration', params)
    },

    // 차단 사용자 목록
    getBlockList() {
        return httpService.get(`/member/block`);
    },

    // 사용자 차단 
    requestUserBlock(params) {
        return httpService.post(`/member/block/${params}`);
    },

    // 사용자 차단 해제
    restoreBlock(params) {
        return httpService.delete(`/member/block/${params}`);
    },

    // 신고 사유 리스트
    getReportReasonList() {
        return httpService.get('/codes/code/REPORT_REASON/combo');
    },
}

export default memberApi
